import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DownloadPdfService } from '../../service/download-pdf.service';
import { MeetingNotesService } from '../../service/meeting-notes.service';
import { SopService } from '../../service/sop.service';
import { ToastMessageService } from '../../service/toast-message.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DocxService } from '../../service/docx.service';


@Component({
  selector: 'app-chat-layout',
  templateUrl: './chat-layout.component.html',
  styleUrls: ['./chat-layout.component.scss']
})
export class ChatLayoutComponent implements OnInit, OnChanges, OnDestroy {

  @ViewChild('scrollChat', { static: false }) scrollContainer!: ElementRef;
  @Output() apiCall = new EventEmitter<any>();
  @Input() methodSelected: any;
  @Input() chatData: any = [];
  @Input() functionList: any = ['GKnowledge'];
  @Input() isReset: boolean = false;
  //mselected: { name: string; } | undefined; // Ensure this matches your actual data structure
  selectedSource: string = 'Sharepoint'; // Default selection
  dataSources: string[] = ['Sharepoint', 'SFDC', 'internet'];
  prompt: any = '';
  generateResponse: boolean = false;
  isOpen = false;
  method1: string = '';
  windowRef = window;
  reqid: any;
  method: string = '';
  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  username: any;

  recentQuestion: any = [];
  researchQuestion: any = [];
  popularQuestion: any = [];
  sfdcQuestion: any = []


  dropdownSettings: any = {};
  accountNameSelected: any = [];
  centerSelected: any = [];

  accountList: any = [];
  buyingCenterList: any = [];
  meetingNotesData: any;
  meetingLoading = false;
  stopCount = 0;
  intervalId: any;
  chatModeSwitch = true;





  modalRef?: BsModalRef;
  constructor(
    private toastMessage: ToastMessageService,
    private downloadPdfService: DownloadPdfService,
    private sopService: SopService,
    private route: ActivatedRoute,
    private meetingNotesService: MeetingNotesService,
    private modalService: BsModalService,
    private docxService: DocxService,
    private router: Router
  ) {
    this.dropdownSettings = {
      singleSelection: true,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
      clearSearchFilter: false,
    };
  }

  ngOnInit(): void {
    //this.method1 = 'initial value';
    this.getUserName();
    this.getRecentResponse();
    this.getSpQuestion();
    this.getIntQuestion();
    this.getSFDCQuestion();
      // this.sopService.pageTitle.next({ title: 'ChatBOT' });
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.isReset) {
      this.prompt = '';
      this.generateResponse = false;
      this.scrollToBottom();
    }
  }

  back() 
  {
    this.router.navigate(['/Home']);
  }

  getIntQuestion() {
    let payload = {
      "function_type": 'GKnowledge',
      "source": "internet",
      "limit": 3
    }
    this.sopService.getQuestion(payload).subscribe(
      (res: any) => {
        if (res?.response?.status == "success") {
          this.researchQuestion = res?.response?.data || [];
        }
      }
    )
  }

  getSFDCQuestion() {
    let payload = {
      "function_type": 'GKnowledge',
      "source": "SFDC",
      "limit": 3
    }
    this.sopService.getQuestion(payload).subscribe(
      (res: any) => {
        if (res?.response?.status == "success") {
          this.sfdcQuestion = res?.response?.data || [];
        }
      }
    )
  }

  getSpQuestion() {
    let payload: any = {
      "function_type": 'GKnowledge'
    }
      payload['source'] = "Sharepoint";
      payload['limit'] = 5;
    

    this.sopService.getQuestion(payload).subscribe(
      (res: any) => {
        if (res?.response?.status == "success") {
          this.popularQuestion = res?.response?.data || [];
        }
      }
    )
  }

  getRecentResponse() {
    let data = {
      "function_type": 'GKnowledge',
    }
    this.sopService.getBotHistory(data).subscribe(
      (res: any) => {
        if (res?.response?.status == "success") {
          const mappedData = res?.response?.data.map((ele: any) => ({
            "question": ele?.prompt,
            "source": ele?.sources // Assuming you intended to use 'sources' here
          }));
          this.recentQuestion = mappedData || [];
          console.log(this.recentQuestion);
        } else {
          this.toastMessage.showError(res?.response?.message);
        }
      },
      (error) => {
        this.toastMessage.showError(error?.message);
      }
    )
  }

  // Function to handle checkbox change
  onCheckboxChange(event: any, value:any) {
    if (event.target.checked) {
      this.selectedSource = value; // Set selectedSource to 'internet' when checkbox is checked
      // Perform any other actions you want here
      this.geAccountList();
    } else {
      this.selectedSource = 'Sharepoint'; // Set selectedSource to empty if checkbox is unchecked
    }
  }

  getOppurtunity() {
    let payload = {
      'account': this.accountNameSelected[0],
      'query': this.prompt
    }
    console.log(payload);
    this.meetingNotesService.oppurtunityChat(payload).subscribe((res: any) => {
      console.log(res);
    });
  }

  // scoroll to bottom in chat window
  scrollToBottom() {
    setTimeout(() => {
      const containerElement = this.scrollContainer.nativeElement;
      containerElement.scrollTop = containerElement.scrollHeight;
    }, 0);
  }

  activateChatWindow(item: any, source: string) {
    this.prompt = item?.question || '';
    this.selectedSource = source || 'Sharepoint';
    if (item?.source) this.selectedSource = item.source;

  }

  //download
  downloadAsPdf() {
    this.downloadPdfService.downloadAsPdf("chat-download-block", 'downloaded-file.pdf');
  }

  // copy to clipboard
  copyToClipboard(text: any) {
    const tempInput = document.createElement('textarea');
    tempInput.value = text;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand('copy');
    document.body.removeChild(tempInput);
  }

  // send promt ot chat GPT api
  userChat(regenerate = false) {
    this.prompt = this.prompt.trim();
    if ((!regenerate && !this.prompt) ||
      (!regenerate && (this.chatData.length == 0) && !this.prompt)) {
     // this.toastMessage.showError('Question is required');
      return;
    }

    if (!regenerate) {
      let question = { "role": "user", "content": this.prompt };
      this.chatData.push(question);
      this.recentQuestion.unshift({ question: this.prompt, source: this.selectedSource || "" })
    } else {
      let lastMessage = this.lastChat();
      this.chatData.push(lastMessage);
      this.recentQuestion.unshift({ question: lastMessage?.content, source: this.selectedSource || "" })
    }

    this.generateResponse = true;
    
    if(this.selectedSource === 'SFDC')
      {
        this.getOppurtunity();
      }
      else{
        let payload: any = { unSubscription: false, data: this.chatData, bot: 'GKnowledge' };

        if (this.methodSelected?.name == 'GKnowledge') {
          payload["source"] = this.selectedSource || "";
        }
    
        this.apiCall.next(payload);
        console.log(this.apiCall);
      }
    


  }

  //get user Name
  getUserName() {
    this.username = localStorage.getItem('okta-username') ? localStorage.getItem('okta-username') as string : 'Guest';
  }

  // get last chat of user
  lastChat() {
    let userChat = this.chatData.filter((ele: any) => ele.role == 'user');

    return userChat.pop();;
  }

  unsubscribeChat() {
    let payload = { unSubscription: true, data: this.chatData };
    this.apiCall.next(payload);
    this.prompt = '';
    this.generateResponse = false;
    this.scrollToBottom();
  }

  // Meeting notes Apis

  openMeetingNotes() {
    document.getElementById('prepMeetingtemplate')?.click();
  }

  geAccountList() {
    this.meetingLoading = true;
    this.openMeetingNotes();
    this.meetingNotesService.getAccount().subscribe(
      (res: any) => {
        this.meetingLoading = false;
        if (res?.status == "success") {
          this.accountList = res?.data || [];
          // this.toastMessage.showSuccess(res?.message);
          
        } else {
          this.toastMessage.showError(res?.message);
        }
      },
      (error) => {
        this.meetingLoading = false;
        this.toastMessage.showError(error?.message);
      }
    )
  }

  // getBuyingCenter() {
  //   this.meetingLoading = true;
  //   this.centerSelected = [];
  //   this.buyingCenterList = ['All'];
  //   let payload = {
  //     "account": this.accountNameSelected[0]
  //   }
  //   this.meetingNotesService.getBuyingCenters(payload).subscribe(
  //     (res: any) => {
  //       this.meetingLoading = false;
  //       if (res?.status == "success") {
  //         this.buyingCenterList= res?.data || [];
  //         this.buyingCenterList.unshift('All')
  //         // this.toastMessage.showSuccess(res?.message);
  //         // document.getElementById('prepMeetingtemplate')?.click();
  //       } else {
  //         this.toastMessage.showError(res?.message);
  //       }
  //     },
  //     (error) => {
  //       this.meetingLoading = false;
  //       this.toastMessage.showError(error?.message);
  //     }
  //   )
  // }

  getMeetingNotes() {
    let payload = {
      "account": this.accountNameSelected[0],
      "buying_center": this.centerSelected[0]
    }

    if (!payload.account || !payload.buying_center) {
      this.toastMessage.showError('Please select buying center');
      return;
    }

    this.meetingLoading = true;
    this.chatModeSwitch = true;




    this.meetingNotesService.getMeetingNotes(payload).subscribe(
      (res: any) => {
        this.modalService.hide();
        this.meetingLoading = false;
        if (res?.status == "success") {
          this.toastMessage.showSuccess(res?.message);
          this.meetingLoading = true;
          this.startInterval();
        } else {
          this.toastMessage.showError(res?.message);
        }
      },
      (error) => {
        this.meetingLoading = false;
        this.toastMessage.showError(error?.message);
      }
    )
  }


  // checking status of file per INterver till successed

  startInterval(): void {
    this.intervalId = setInterval(() => {
      // this.getMeetingNotesStatus();
    }, 15000); // 15 seconds in milliseconds
  }

  stopInterval() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.meetingLoading = false;
      this.stopCount = 0;
    }
  }

  // getMeetingNotesStatus() {
  //   this.meetingNotesService.meetingNotesStatus()
  //     .subscribe(
  //       (res: any) => {
  //         if (res?.status == 'success') {
  //           this.stopCount++;
  //           if (res.data !== 0) {
  //             this.stopInterval();
  //             this.meetingNotesData = res?.data;
  //             // this.toastMessage.showSuccess(res?.message);
  //             this.chatModeSwitch= false;
  //           }

  //           if (this.stopCount > 40) {
  //             this.toastMessage.showWarning('Please try again later.');
  //             this.stopInterval();
  //           }

  //         } else {
  //           this.toastMessage.showError(res?.message);
  //           this.stopInterval();
  //         }

  //       },
  //       (error) => {
  //         // Handle the error here
  //         this.stopInterval();
  //         console.error(error);
  //         this.toastMessage.showError(error?.message);
  //       }
  //     );
  // }


  openModal(template: TemplateRef<void>) {
    this.modalRef = this.modalService.show(template,{ignoreBackdropClick: true});
  }

  onItemSelect(event: any) {
    console.log(event)
    // this.getBuyingCenter();
  }


  downloadDocx(): void {
    // Generate and download the .docx file
    // this.meetingNotesData ="<h3>Meeting Note with Customer Maruti</h3>\n<h4>Latest Maruti News</h4>\n<h4>Maruti Suzuki - Accomplishments, Sales, and Financials</h4>\n\nMaruti Suzuki India Limited, a subsidiary of the globally renowned Suzuki Motor Corporation of Japan, is India's leading passenger car manufacturer, accounting for over 50% of domestic car sales market. As the country's top carmaker, Maruti Suzuki has experienced significant developments in its sales and market share in recent years, along with some key financial accomplishments.\n\n<h4>Performance Highlights</h4>\n\nFor the fiscal year 2022-23, Maruti Suzuki achieved its highest-ever annual sales volume, exports, turnover, and net profit. The company crossed a turnover of INR One Lakh Crore and announced its highest-ever dividend of INR 90 per share.\n\nFurthermore, the company launched nearly half a dozen models in the past year, including the Grand Vitara and the Brezza. This move led to a significant surge in its market share, growing from 7.3% in fiscal 2022 to 26.2% in the previous fiscal year. As of the first two months of Fiscal 2024, the share further increased to 28.8%.\n\n<h4>Stock Performance</h4>\n\nThe company's share price has experienced a substantial rise over the past year. As of January 12, 2024, the share price stood at INR 9,970. For the year 2023, stock prices achieved an impressive 26% return, reaching an all-time high of INR 10,720 on the National Stock Exchange.\n\n<h4>Financial Results</h4>\n\nRegarding the financial performance, in the quarter ending March 2023, Maruti Suzuki reported a year-on-year increase of 43% in its standalone net profit, amounting to INR 2,624 Crores. This growth is attributed to better volumes and improved realization.\n\nIn Q1 FY2021-22, the company's net sales stood at INR 16,798.7 crore, marking a substantial increase compared to the net sale of INR 3,677.5 crore in Q1 FY2020-21.\n\n<h4>Recent Developments and Challenges</h4>\n\nWhile the company has experienced a boost in its sales and financial performance, it has also faced some challenges. In December of 2023, Maruti Suzuki reported a 6.5% dip in passenger vehicle (PV) sales in the domestic market.\n\nFurthermore, Suzuki Motor Gujarat Pvt Ltd received an adjudication order from the Gujarat GST authority, upholding a demand of INR 173.9 Crores along with a penalty of INR 17.4 Crores related to tax liability.\n\n<h4>Key Revenue and Net Worth</h4>\n\nMaruti Suzuki has a significant market capitalization of INR 316048.47 Crore and a robust earnings per share of INR 361.06. The company's annual revenue for the fiscal year 2022-23 surpassed INR One Lakh Crore for the first time.\n\nIn summary, Maruti Suzuki has displayed impressive growth in its sales, market share, and financial performance, despite certain challenges. The company’s growth trajectory and robust financials reflect its strong market presence and financial stability, maintaining a standout performance in the automotive industry.\n\n<h4>References </h4>\n<a href='https://economictimes.indiatimes.com/Maruti-Suzuki-India-Ltd/stocksupdate/companyid-11890.cms'>https://economictimes.indiatimes.com/Maruti-Suzuki-India-Ltd/stocksupdate/companyid-11890.cms</a><br/><a href='https://www.google.com/finance/quote/MARUTI:NSE'>https://www.google.com/finance/quote/MARUTI:NSE</a><br/><a href='https://www.marutisuzuki.com/corporate/media/press-releases/2023/april/maruti-suzuki-announces-financial-results'>https://www.marutisuzuki.com/corporate/media/press-releases/2023/april/maruti-suzuki-announces-financial-results</a><br/><a href='https://www.reuters.com/markets/companies/MRTI.NS'>https://www.reuters.com/markets/companies/MRTI.NS</a><br/><a href='https://economictimes.indiatimes.com/industry/auto/cars-uvs/maruti-moves-up-value-chain-makes-its-presence-felt-in-premium-segment/articleshow/100972765.cms'>https://economictimes.indiatimes.com/industry/auto/cars-uvs/maruti-moves-up-value-chain-makes-its-presence-felt-in-premium-segment/articleshow/100972765.cms</a><br/>\n\n<h4>Previous Conversations</h4>\nBased on the JSON data received, here is the information in a human understandable format:\n\n1. The total size of the data is 1, and the operation is completed successfully.\n2. The record is of the type \"Event\" and the URL for the event is \"/services/data/v56.0/sobjects/Event/00U9D00000BppzHUAR\".\n3. The description of the event contains a warning about the email originating from outside of Genpact. It advises not to reply, click on links, or open attachments unless the sender is recognized and the content is known to be safe.\n4. The email is about scheduling a kick-off call to review the onboarding status of Vandana’s Data Analyst Requirement.\n5. The email is signed by Samyukta and contains information about how to join the Webex meeting.\n6. The purpose or objective of the event is \"New Introductions\".\n7. The outcome of the event is planning for a \"Follow-On Conversation for IO\".\n8. The event is related to the account named \"Maruti\".\n9. The last modification date of the event is \"2023-12-26T08:31:38.000+0000\".\n10. There is no offering associated with this event.\n\n<h4>Deals We Have Pursued in a Particular Buying Center</h4>\nThe SOQL command has executed successfully, but it did not find any Opportunity records in the database.\nBased on the provided JSON data, it appears that there are no records available. Therefore, it's not possible to form the 'Won Opportunities' and 'Lost Opportunities' tables. The JSON data should contain the necessary information, such as 'SFDC ID', 'Opportunity Name', 'TCV', 'Stage', 'Contract Type', 'Service Line/Capability', 'Offerings', 'Partner Names', 'Customer Contact Name(s)', 'Buying Center', 'Reason for Loss', 'Competition' etc. \n\nPlease provide a JSON data with the necessary information to create the tables.\n<h4>Genpact’s Right to Play </h4>\n**Meeting Notes**\n\n**Client**: Maruti Suzuki India Ltd\n\n**Date**: [Insert Date]\n\n**Participants**: [Insert Names]\n\n**Agenda**:\n1. Review of previous interactions and discussions\n2. Analysis of the client’s current status and performance\n3. Discussion of potential opportunities and offerings from Genpact\n\n**Discussion**:\n\n**1. Previous Interactions**:\nIn the last interaction, a kick-off call was scheduled to review the onboarding status of Vandana’s Data Analyst Requirement. The meeting was focused on \"New Introductions\" and planning for a \"Follow-On Conversation for IO\".\n\n**2. Client’s Current Status**:\nMaruti Suzuki India Ltd is currently India's largest passenger car company, holding over 50% of the domestic car market share. Despite a decline in total passenger car sales by 29% in December 2023, Maruti has shown robust financial performance, with a surge in net profit and revenue from operations. Maruti's share price has also seen a significant surge, delivering a 26% return to investors in 2023, reflecting the strong investor confidence.\n\n**3. Opportunities and Genpact Offerings**:\nBased on Maruti's recent performance and priorities, Genpact can assist in several ways:\n\n- **Automation Services**: Implementing an integrated automation framework could help Maruti streamline its operations and reduce manual effort. Genpact’s experience with a manufacturing major in the USA has shown significant reduction in backlog and manual effort.\n\n- **IT Outsourcing and Transformation**: Genpact could help Maruti reduce its IT total cost of ownership (TCO) through a combination of consolidating tools, continuous process improvements, right shoring of non-strategic roles, and re-badging of critical talent.\n\n- **Cybersecurity Services**: As Maruti continues to grow and protect its digital assets, Genpact's offerings in privileged access management, access management, and risk assessment could be crucial.\n\n**Points to be taken care of**:\n\n1. Understand Maruti's current IT infrastructure and identify areas where automation could be implemented for operational efficiency.\n2. Discuss the potential of IT outsourcing and transformation to reduce Maruti's TCO.\n3. Highlight the importance of cybersecurity and how Genpact can assist in managing and mitigating cyber risks.\n4. Monitor Maruti's market performance and financial health to align Genpact's offerings with their current and future needs.\n5. Maintain regular communication and follow-up to ensure Maruti's needs are met and to identify new opportunities. \n\n**Next Steps**:\n\n1. Schedule a follow-up meeting to discuss Genpact's offerings in detail.\n2. Prepare a detailed proposal highlighting how Genpact can assist Maruti in automation, IT transformation, and cybersecurity.\n3. Continue monitoring Maruti's performance for potential opportunities.\n\n**Documents Used**:\nEverest Group_Retail and CPG IT Services PEAK Matrix® Assessment 2024_Briefing deck.pptx, Platform Managed Services Capability Overview.pptx, Automation Case Study.pptx, GTalk_Cybersecurity Offerings_30 June.pptx.";
    let html = document.getElementById('chat-download-block')?.innerHTML;
    this.docxService.generateDocx(html, this.accountNameSelected[0] + '_' + this.centerSelected[0]);

    // this.docxService.generateDocx(this.meetingNotesData, this.accountNameSelected[0] + '_' + this.centerSelected[0]);
  }


  ngOnDestroy(): void {
    // this.sopService.pageTitle.next({ title: 'Konverse AI' });
  }

}

